import React from 'react'
import Banner from '../birthdances/Banner'

const Birthdance2024 = () => {
  return (
    <div><Banner /></div>
  )
}

export default Birthdance2024